import React from 'react';
import './SiteHeader.css';

interface SiteHeaderProps {
  mode: 'preview' | 'live';
}

const SiteHeader: React.FC<SiteHeaderProps> = ({ mode }) => {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <a href="https://gotap.it/" className="site-header__brand" aria-label="GoTap home" target="_blank" rel="noopener noreferrer">
          <span className="brand-mark">GoTap</span>
          {/* <span className="brand-sub">Link in Bio</span> */}
        </a>
        <div className="site-header__right">
          {/* <span className={`mode-badge ${mode}`}>{mode === 'preview' ? 'Preview' : 'Live'}</span> */}
        </div>
      </div>
    </header>
  );
};

export default SiteHeader;


